<template>
  <div class="wg-row">
    <!-- Filtro a tre colonne -->
    <div 
        id="list-filter-btns"
        class="wg-row project-list-filter-btns wg-md-none">
      <div v-for="(filterBtn, index) in filterBtns" :key="index" class="wg-col wg-xs-4">
        <div
            :id="'list-filter-btn-'+filterBtn.id" 
            :class="{selected: selectedStatus === filterBtn.id}"
            @click="changeStatus(filterBtn.id)">
          {{ filterBtn.label }}
        </div>
      </div>
    </div>
    <!-- Intestazione 3 colonne - sopra md -->
    <div id="list-cols-labels" class="wg-row list-cols-labels" style="align-items:center;">
      <div 
          v-for="(filterBtn, index) in filterBtns" 
          :key="index" 
          class="wg-col wg-xs-4 display-flex com-anm22-app-text-l" 
          style="font-weight:bold;justify-content:center;">
        {{ filterBtn.label }}
      </div>
    </div>
    <div class="wg-row">
      <div 
          id="status-projects-list-waiting"
          class="wg-col wg-xs-12 wg-md-4 status-projects-list com-anm22-app-scrolling-panel" 
          v-show="selectedStatus === 'waiting' || windowWidth > 991"
          style="padding:0 5px;"
          @scroll="getNextProjects('waiting')">
      <template v-if="separateUrgent">
        <project-bar 
            v-for="(pdata) in waitingProjectsData[0]" 
            :key="'waiting-u-' + pdata.id"
            :projectData="pdata" 
            :view="'cols'"
        ></project-bar>
        <div v-if="waitingProjectsData[0].length && waitingProjectsData[1].length" class="separator" ></div>
        <project-bar 
            v-for="(pdata) in waitingProjectsData[1]" 
            :key="'waiting-'+ pdata.id"
            :projectData="pdata" 
            :view="'cols'"
        ></project-bar>
      </template>
      <project-bar 
          v-else
          v-for="(pdata) in waitingProjectsData.slice(0,projectsListsLimit['waiting'])" 
          :key="'waiting-'+ pdata.id"
          :projectData="pdata" 
          :view="'cols'"
      ></project-bar>
      </div>
      <div 
          id="status-projects-list-running"
          class="wg-col wg-xs-12 wg-md-4 status-projects-list com-anm22-app-scrolling-panel" 
          v-show="selectedStatus === 'running' || windowWidth > 991"
          style="padding:0 5px;"
          @scroll="getNextProjects('running')">
        <template v-if="separateUrgent">
          <project-bar 
              v-for="(pdata) in runningProjectsData[0]" 
              :key="'running-u-' + pdata.id"
              :projectData="pdata" 
              :view="'cols'"
          ></project-bar>
          <div v-if="runningProjectsData[0].length && runningProjectsData[1].length" class="separator" ></div>
          <project-bar 
              v-for="(pdata) in runningProjectsData[1]" 
              :key="'running-'+ pdata.id"
              :projectData="pdata" 
              :view="'cols'"
          ></project-bar>
        </template>
        <project-bar 
            v-else
            v-for="(pdata) in runningProjectsData.slice(0,projectsListsLimit['running'])" 
            :key="'running-'+ pdata.id"
            :projectData="pdata" 
            :view="'cols'"
        ></project-bar>
      </div>
      <div 
          id="status-projects-list-completed"
          class="wg-col wg-xs-12 wg-md-4 status-projects-list com-anm22-app-scrolling-panel" 
          v-show="selectedStatus === 'completed' || windowWidth > 991"
          style="padding:0 5px;"
          @scroll="getNextProjects('completed')">
        <project-bar 
            v-for="(pdata) in completedProjectsData.slice(0,projectsListsLimit['completed'])" 
            :key="'completed-'+ pdata.id"
            :projectData="pdata" 
            :view="'cols'"
        ></project-bar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProjectBar from '../project/ProjectBar.vue';

export default {
  components: {
    ProjectBar
  },
  props: {
    projectsData: {
      type: Array,
      required: true
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true
    },
    separateUrgent: {
      type: Boolean,
      default: false
    },
    orderingField: {
      type: String,
      default: 'deadline'
    },
    orderingDir: {
      type: String,
      default: 'ASC'
    }
  },
  data() {
    return {
      selectedStatus: this.$anm22.getCookie('tk_p_status') !== '' ? this.$anm22.getCookie('tk_p_status') : "running",
      projectsListLimit: 20,
      projectsListsLimit: {},
      statusList: ['waiting','running','completed'],
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }),
    waitingProjectsData() {
      if(this.separateUrgent) {
        return [
          this.projectsData
            .filter(p => (p.status === 1 || p.status === 6) && p.urgent)
            .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir)),
          this.projectsData
            .filter(p => (p.status === 1 || p.status === 1) && !p.urgent)
            .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir))
        ];
      } else {
        return this.projectsData
          .filter(p => p.status === 1 || p.status === 6)
          .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir))
      }
    },
    runningProjectsData() {
      if(this.separateUrgent) {
        return [
          this.projectsData
            .filter(p => p.status === 2 && p.urgent)
            .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir)),
          this.projectsData
            .filter(p => p.status === 2 && !p.urgent)
            .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir)),
        ];
      } else {
        return this.projectsData
          .filter(p => p.status === 2)
          .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir))
      }
    },
    completedProjectsData() {
      return this.projectsData
          .filter(p => (p.status === 3 || p.status === 4 || p.status === 5))
          .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir));
    },
    filterBtns() {
      return [
        {
          id: "waiting",
          label: this.$anm22.strLang(this.lang, "Waiting", "In attesa")
        },
        {
          id: "running",
          label: this.$anm22.strLang(this.lang, "Running", "In corso")
        },
        {
          id: "completed",
          label: this.$anm22.strLang(this.lang, "Completed", "Completati")
        }
      ];
    },
  },
  methods: {
    changeStatus(status) {
      this.selectedStatus = status;
      this.$anm22.setCookie('tk_p_status', status, 31536000);
    },
    getNextProjects(statusId) {
      const itemsNum = this.projectsListLimit;
      let bottomOfList = document.getElementById('status-projects-list-' + statusId).scrollTop + document.getElementById('status-projects-list-' + statusId).clientHeight >= this.projectsListsLimit[statusId] * 43;
      if (bottomOfList) {
        this.projectsListsLimit[statusId] += itemsNum;
        console.log("Loading next projects...");
        this.$forceUpdate();
      }
    },
    checkListLimitAfterResize() {
      window.addEventListener('resize', (event) => {
        if (window.innerHeight / 43 >= this.projectsListLimit) {
          this.projectsListLimit = Math.round(window.innerHeight / 43);
          console.log("Resized kanbann to " + this.projectsListLimit + " items");
        }
        this.statusList.forEach((status)=>{
          if (this.projectsListsLimit[status] < this.projectsListLimit) {
            this.projectsListsLimit[status] = this.projectsListLimit;
          }
        });
      }, true);
    },
  },
  created() {
    if (window.innerHeight / 43 >= this.projectsListLimit) {
      this.projectsListLimit = Math.round(window.innerHeight / 43);
      console.log("Resized kanbann to " + this.projectsListLimit + " items");
    }
    this.statusList.forEach((status)=>{
      this.projectsListsLimit[status] = this.projectsListLimit;
    });
  },
}
</script>

<style lang="scss" scoped>
.separator {
  background-color: #fff;
  box-shadow: 0 3px 8px 0 rgba(0,0,0,0.03);
  border-bottom: 2px solid #ddd;
  margin-bottom: 8px;
  height: 1px;
}
.none {
  display: none;
}
.status-projects-list {
  max-height: calc(100vh - 260px);
}
@media screen and (max-width: 990px){
  .status-projects-list {
    max-height: calc(100vh - 302px);
  }
}
</style>